import { Sku } from './sku'

export class Item extends Sku {

  item_id: number
  batch_id: number
  mark: boolean
  flag: boolean
  count: number
  sold_count: number
  price: number
  pre_tax_price: number
  tax_rate: number
  commission_rate: number
  exchange_rate: number
  shipping_fee: number
  cost: number
  batch_number: string
  location: string
  location_code: number
  at_home: boolean
  purchaser: string
  write_off_date: string
  reason: string
  purchase_date: string
  receive_date: string
  comment: string
  write_off: boolean

  constructor(data: any = {}) {
    super(data)
    this.item_id = data.item_id
    this.batch_id = data.batch_id
    this.count = data.count || 0
    this.sold_count = data.sold_count || 0
    this.price = data.price || 0
    this.pre_tax_price = data.pre_tax_price || 0
    this.tax_rate = data.tax_rate || 0
    this.commission_rate = data.commission_rate || 0
    this.exchange_rate = data.exchange_rate || 1
    this.shipping_fee = data.shipping_fee || 0
    this.cost = data.cost || 0
    this.batch_number = data.batch_number
    this.location = data.location
    this.location_code = data.location_code
    this.at_home = data.at_home || false
    this.purchaser = data.purchaser
    this.write_off_date = data.write_off_date
    this.reason = data.reason
    this.purchase_date = data.purchase_date
    this.receive_date = data.receive_date
    this.comment = data.comment
    this.mark = Boolean(data.mark)
    this.flag = Boolean(data.flag)
    this.write_off = Boolean(data.write_off)
  }

  public upateProps(data: any) {
    Object.keys(data).forEach(key => this[key] = data[key])
  }

  get locationClass(): string {
    switch (this.location_code) {
      case 1: return 'success'
      case 2: return 'danger'
      case 3: return 'warning'
      case 4: return 'info'
      default: return 'default'
    }
  }

  get itemTableRowClass(): string {
    return this.location_code === 1 ? '' : 'warning'
  }

  get locationBtnClass(): string {
    return 'btn-' + this.locationClass
  }

  get original_count(): number {
    return this.count + this.sold_count
  }

  get remaining_count(): number {
    return this.original_count - this.count;
  }

  get disableDelete(): boolean {
    return this.original_count > this.count ? true : false
  }

  get counts(): number[] {
    return Array.apply(null, {length: this.count + 1}).map(Number.call, Number).slice(1)
  }

  get link(): string {
    return `/inventory/items/${this.item_id}`
  }

  get batch_link(): string {
    return `/batches/${this.batch_id}/items`
  }

  get writeOffText(): string {
    return this.write_off ? '已清零 (点击取消清零)' : '未清零 (点击清零)'
  }

  get submitWriteOffText(): string {
    return this.write_off ? '确定取消清零' : '确定清零'
  }

  get editWriteOffLink(): string {
    return `/inventory/write-offs/edit/${this.item_id}`
  }

  public toggleFlag() {
    this.flag = !this.flag
  }

  public toggleMark() {
    this.mark = !this.mark
  }

  get sku_link(): string {
    return `/import/skus/${this.sku_id}`
  }

  public updateLocationAndCode(location: string, code: number) {
    this.location = location
    this.location_code = code
  }

}



// WEBPACK FOOTER //
// ./src/app/models/item/item.ts